import { useNavigate } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import { Button } from "../components/ui/Button";
import { useAuth } from "../hooks/useAuth";
import { useLandingTarget } from "../hooks/useDefaultRoute";

export default function UnauthorizedPage() {
  const navigate = useNavigate();
  const { setActiveBusiness } = useAuth();
  const resolveTarget = useLandingTarget();

  const handleGoToDashboard = () => {
    const { businessId, route } = resolveTarget();
    if (businessId) setActiveBusiness(businessId);
    navigate(route, { replace: true });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f8fafc] p-4">
      <div className="flex flex-col items-center gap-6 text-center max-w-sm">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#fef2f2]">
          <ShieldOff className="h-8 w-8 text-[#dc2626]" />
        </div>
        <div>
          <h1 className="text-xl font-bold text-[#0f172a]">Access Denied</h1>
          <p className="mt-2 text-sm text-[#64748b]">
            You don't have permission to view this page. Please contact your administrator if you
            believe this is an error.
          </p>
        </div>
        <Button variant="secondary" onClick={handleGoToDashboard}>
          Go to Dashboard
        </Button>
      </div>
    </div>
  );
}
